@if (isOffline) {
  <div class="row">
    <div class="col-12 pl-4">
      <ebs-message-simple [iconCssClasses]="'text-info icon-gecko-offline'" [textCssClasses]="'text-info'"
      [displayMessage]="offlineMessage"></ebs-message-simple>
    </div>
  </div>
}